export enum MediaQuery {
  Xsm = '(min-width: 640px)',
  Sm = '(min-width: 960px)',
  Md = '(min-width: 1200px)',
  Lg = '(min-width: 1600px)',
}
